import { ICON_BUTTON_ICONS } from '../../../../components/buttons/IconButton';
import { UI_OPTION_KEYS } from '../../../../utils/constants/uiOptionKeys';
import { UI_OPTIONS } from '../../../../utils/constants/uiOptions';

export default [
  {
    name: 'Relevance (default)',
    shortName: 'Relevance (default)',
    value: 'default',
    onlyForSearchType: 'all'
  },
  {
    name: 'Fund name (a → z)',
    shortName: 'Fund name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE].Funds
  },
  {
    name: 'Fund name (z → a)',
    shortName: 'Fund name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE].Funds
  },
  {
    name: 'Portfolio name (a → z)',
    shortName: 'Portfolio name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE]['Portfolio Co.']
  },
  {
    name: 'Portfolio name (z → a)',
    shortName: 'Portfolio name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE]['Portfolio Co.']
  },
  {
    name: 'Invest profile name (a → z)',
    shortName: 'Invest profile name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE].Corporates
  },
  {
    name: 'Invest profile name (z → a)',
    shortName: 'Invest profile name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE].Corporates
  },
  {
    name: 'Acquisition date (1 → 9)',
    shortName: 'Acquisition date',
    value: 'acquisitionDate-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE]['Portfolio Co.']
  },
  {
    name: 'Acquisition date (9 → 1)',
    shortName: 'Acquisition date',
    value: 'acquisitionDate-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForSearchType: UI_OPTIONS[UI_OPTION_KEYS.SEARCH_TYPE]['Portfolio Co.']
  },
  {
    name: 'Sales (min) (1 → 9)',
    shortName: 'Sales (min)',
    value: 'revenueMin-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForSearchType: 'all'
  },
  {
    name: 'Sales (max) (9 → 1)',
    shortName: 'Sales (max)',
    value: 'revenueMax-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForSearchType: 'all'
  },
  {
    name: 'EBITDA margin (1 → 9)',
    shortName: 'EBITDA margin',
    value: 'ebitdaMargin-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForSearchType: 'all'
  },
  {
    name: 'EBITDA margin (9 → 1)',
    shortName: 'EBITDA margin',
    value: 'ebitdaMargin-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForSearchType: 'all'
  },
  {
    name: 'EBITDA (min) (1 → 9)',
    shortName: 'EBITDA (min)',
    value: 'ebitdaMin-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForSearchType: 'all'
  },
  {
    name: 'EBITDA (max) (9 → 1)',
    shortName: 'EBITDA (max)',
    value: 'ebitdaMax-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForSearchType: 'all'
  },
  {
    name: 'Enterprise Value (min) (1 → 9)',
    shortName: 'Enterprise Value (min)',
    value: 'enterpriseMin-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForSearchType: 'all'
  },
  {
    name: 'Enterprise Value (max) (9 → 1)',
    shortName: 'Enterprise Value (max)',
    value: 'enterpriseMax-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForSearchType: 'all'
  }
];
